<template>
    <div class="border-top">
        <SOFilterTitle :title="'Memiliki saldo E-Payment'" :diterapkan="diterapkan" :id="id"/>
        <div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
            <SOInputNominal
                class="p-d-16"
                :title="'Minimal'"
                :prefix-left="true"
                :placeholder="'123.456'"
                :prefix="'Rp'"
                :defaultValue="filterItem.filterSaldoEpayment.minimal.toString()"
                @input="setMininal"
            />
            <SOInputNominal
                :title="'Maksimal'"
                :prefix-left="true"
                :placeholder="'123.456'"
                :prefix="'Rp'"
                :defaultValue="filterItem.filterSaldoEpayment.maksimal.toString()"
                @input="setMaksimal"
            />
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex"

import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";

export default {
    name: "SOFilterSaldoEpayment",
    components: {
        SOFilterTitle,
        SOInputNominal,
    },
    props: {
        id: String,
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem"
        })
    },
    mounted() {
        this.diterapkan = this.filterItem.kontakKonsumen.length > 0
    },
    watch: {
        "filterItem.kontakKonsumen": {
            handler: function () {
                this.diterapkan = this.filterItem.kontakKonsumen.length > 0
            }
        }
    },
    data() {
        return {
            diterapkan: false,
	        delay: {
				setMinimal: null,
		        setMaksimal: null,
	        }
        }
    },
    methods: {
        setMininal(val) {
            let temp = this.filterItem
            temp.filterSaldoEpayment.minimal = val.raw
            this.$store.commit("filterGlobalModule/setFilterItem", temp)
            this.diterapkan = this.filterItem.filterSaldoEpayment.minimal !== 0 || this.filterItem.filterSaldoEpayment.maksimal !== 0
			// clearTimeout(this.delay.setMinimal)
	        // this.delay.setMinimal = setTimeout(() => {
		    //     let temp = this.filterItem
            //     temp.filterSaldoEpayment.minimal = val.raw
		    //     if (val.raw > temp.filterSaldoEpayment.maksimal && temp.filterSaldoEpayment.maksimal !== 0) {
			// 		setTimeout(() => {
			// 			temp.filterSaldoEpayment.maksimal = temp.filterSaldoEpayment.minimal
			// 		})
		    //     }
		    //     this.$store.commit("filterGlobalModule/setFilterItem", temp)
		    //     this.diterapkan = this.filterItem.filterSaldoEpayment.minimal !== 0 || this.filterItem.filterSaldoEpayment.maksimal !== 0
	        // }, 500)
        },
        setMaksimal(val) {
            let temp = this.filterItem
            temp.filterSaldoEpayment.maksimal = val.raw
            this.$store.commit("filterGlobalModule/setFilterItem", temp)
            this.diterapkan = this.filterItem.filterSaldoEpayment.minimal !== 0 || this.filterItem.filterSaldoEpayment.maksimal !== 0

	        // clearTimeout(this.delay.setMaksimal)
	        // this.delay.setMaksimal = setTimeout(() => {
		    //     let temp = this.filterItem
		    //     if (temp.filterSaldoEpayment.minimal > val.raw && temp.filterSaldoEpayment.minimal !== 0) {
			//         temp.filterSaldoEpayment.maksimal = 0
			//         setTimeout(() => {
			// 	        temp.filterSaldoEpayment.maksimal = temp.filterSaldoEpayment.minimal
			//         }, 100)
		    //     } else {
			//         temp.filterSaldoEpayment.maksimal = val.raw
		    //     }
		    //     this.$store.commit("filterGlobalModule/setFilterItem", temp)
		    //     this.diterapkan = this.filterItem.filterSaldoEpayment.minimal !== 0 || this.filterItem.filterSaldoEpayment.maksimal !== 0
	        // }, 1000)
        },
    }
}
</script>